import Footer from "../../footer"
import NavBar from "../../nav"

const Regulations = () => {
  return <div className='regulations'>
    <NavBar />
    <div>
    <section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>Frequently Asked Regulations</h1>
				<div className="headline-divider"></div>
				<h2>Certifications. Authorizations. Compliance.</h2>
			</div>
		</section>
    <section className="clean-block clearfix">
			<div className="container content-container far-container clearfix">	
				<div className="container-fluid">
					<div className="row">
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist.png" alt="" /></div>
								<div className="checklist-header">Exclusive Use Aircraft</div>
							</div>
							<div className="question">May a 135 exclusive use aircraft be flown part 91.</div>
							<div className="get-answer" data-id="2">Get Answer</div>
						</div>
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist.png" alt="" /></div>
								<div className="checklist-header">SIC Training</div>
							</div>
							<div className="question">What type of training is required for a SIC under 135?</div>
							<div className="get-answer" data-id="3">Get Answer</div>
						</div>
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist.png" alt="" /></div>
								<div className="checklist-header">14 CFR 135.269</div>
							</div>
							<div className="question">May an augmented crew use 135.267 for the rest requirements?</div>
							<div className="get-answer" data-id="4">Get Answer</div>
						</div>
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist.png" alt="" /></div>
								<div className="checklist-header">14 CFR 135.267(c)</div>
							</div>
							<div className="question">May a crewmember exceed 14 hours of duty in 24 hour period?</div>
							<div className="get-answer" data-id="1">Get Answer</div>
						</div>
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist-red.png" alt="" /></div>
								<div className="checklist-header">Submit your question.</div>
							</div>
							<textarea id="form_regulatory_question" name="form_regulatory_question"></textarea>
                            <div className="checklist-container cap-container clearfix">
                                <img className="cap-img" src="/__includes/contact/captcha.php" alt="" />
                                <img className="cap-refresh" src="/assets/img/refresh.png" alt="Refresh Captcha" data-type="contact-us" />
                                <i className="fas fa-redo refresh-captcha"></i>
                                <input type="text" id="captcha" name="captcha_challenge" className="form-control form-field cap-input" data-type="contact-us" placeholder="Enter Code" />							
                            </div>
							<button id="form_btn_send" className="btn btn-primary btn-block btn_action first-button">Submit</button>
						</div>
					</div>
				</div>
			</div>
		</section>

    <section className="clean-block cleanfix">
			<div className="divider sections">Regulatory Questions &amp; Answers</div>
			<div id="regulationcontainer" className="accordion accordion-container content-container">
				<div className="card">	
					<div className="regulationcategory">Flight Data Recorder 135.152(a)</div>
					<div className="card-header">
						{/* <a name="qa-11"></a> */}
						<button className="btn btn-link accordion-button collapsed" type="button" data-toggle="collapse" data-target="#collapse-11" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">FDR Requirements 135.152(a)</div>
						</button>
					</div>
					<div id="collapse-11" className="accordion-display collapse" aria-labelledby="heading-11" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						Flight Data Recorders (FDR) for 10 to 19 passenger seat aircraft are not required to have an FDR unless added to the FAA registry and added to a 135 certificate after October 11, 1991.						
				    </div>
				</div>
					<div className="regulationcategory">Exclusive Use Aircraft</div>
					<div className="card-header">
						{/* <a name="qa-2"></a> */}
						<button className="btn btn-link accordion-button" type="button" data-toggle="collapse" data-target="#collapse-2" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">May a 135 exclusive use aircraft be flown part 91.</div>
						</button>
					</div>
					<div id="collapse-2" className="collapse accordion-display" aria-labelledby="heading-2" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						Yes provided the employees of the certificate holder retain Operational Control.  Reference FAA RCCB November 25, 2019.  Operational Control must be retained at all times by the owner of the certificate and aircraft.                        <div className="far-file">
						<a href="/uploads/fars/2/rccb_part135.pdf" target="_blank" rel="noreferrer">View File</a>
            </div>
						
				    </div>
				</div>
					<div className="regulationcategory">SIC Training</div>
					<div className="card-header">
						{/* <a name="qa-3"></a> */}
						<button className="btn btn-link accordion-button" type="button" data-toggle="collapse" data-target="#collapse-3" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">What type of training is required for a SIC under 135?</div>
						</button>
					</div>
					<div id="collapse-3" className="collapse accordion-display" aria-labelledby="heading-3" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						The training curriculum is the same however a PIC will have one more check i.e. 135.299.						
				    </div>
				</div>
					<div className="regulationcategory">Manual Procedure Violation</div>
					<div className="card-header">
						{/* <a name="qa-5"></a> */}
						<button className="btn btn-link accordion-button" type="button" data-toggle="collapse" data-target="#collapse-5" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">Can a pilot/operator be violated for acting contrary to a referenced operating manual required by 14 CFR 121.135 or 135.23</div>
						</button>
					</div>
					<div id="collapse-5" className="collapse accordion-display" aria-labelledby="heading-5" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						Anyone who violates FAA regulations could be subject to enforcement action, however, manuals provide guidance for company policies and procedures a determination will need to be made on the regulatory violation.						
				    </div>
				</div>
					<div className="regulationcategory">Aircraft Deicing</div>
					<div className="card-header">
						{/* <a name="qa-6"></a> */}
						<button className="btn btn-link accordion-button" type="button" data-toggle="collapse" data-target="#collapse-6" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">Can a pilot deice an aircraft under 135?</div>
						</button>
					</div>
					<div id="collapse-6" className="collapse accordion-display" aria-labelledby="heading-6" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						"Yes however the certificate holder will need OpSpecs A041 to ensure a clean wing per 135.227(b) within 5 minutes of departure and that the crew is trained under the certificate holders approved training program.<br /><br />Note: OpSpecs A023 is difficult for most 135 operators to comply with all the requirements."						
				    </div>
				</div>
					<div className="regulationcategory">International Travel</div>
					<div className="card-header">
						{/* <a name="qa-7"></a> */}
						<button className="btn btn-link accordion-button" type="button" data-toggle="collapse" data-target="#collapse-7" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">What are the limitations of operating in foreign countries?</div>
						</button>
					</div>
					<div id="collapse-7" className="collapse accordion-display" aria-labelledby="heading-7" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						<strong>14 212.1</strong> All charter flights, and all other flights carrying charter passengers or cargo, in interstate and/or foreign air transportation by U.S. certificated air carriers or in foreign air transportation by foreign air carriers. It does not apply to any flights performed by a commuter air carrier, air taxi operator, or certificated air carrier operating "small aircraft" under part 298 of this chapter. Nothing in this part gives authority to operate a type or level of service not authorized by certificate, foreign air carrier permit, or exemption, except that a certificated air carrier authorized to conduct scheduled operations may conduct charter flights, in interstate and/or foreign air transportation, without limitation as to the points served.<br /><br /><strong>14 CFR 212.2 Definition</strong><br /><strong>Fourth freedom</strong> charter means a charter flight carrying traffic that terminates in the carrier's home country having originated in another country.<br /><strong>Fifth freedom</strong> charter means a charter flight carrying traffic that originates and terminates in countries other than the carrier's home country, regardless of whether the flight operates via the home country.<br /><strong>Seventh-freedom</strong> charter means a charter flight carrying traffic that originates and terminates in a country other than the foreign air carrier's home country, where the flight does not have a prior, intermediate, or subsequent stop in the foreign air carrier's home country.<br /><br /><strong>19 CFR 122.165</strong><br />Operating with the US between two points with a foreign registered aircraft is prohibited unless reciprocity is received.  Note exemptions of the rule.<br /><br /><strong>14 CFR 61.3(a)(vii)</strong><br />Foreign Pilot may operate a "N" aircraft if when operating an aircraft within a foreign country, a pilot license issued by that country may be used.						
				    </div>
				</div>
					<div className="card-header">
						{/* <a name="qa-10"></a> */}
						<button className="btn btn-link accordion-button" type="button" data-toggle="collapse" data-target="#collapse-10" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">Aircraft Registration</div>
						</button>
					</div>
					<div id="collapse-10" className="collapse accordion-display" aria-labelledby="heading-10" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						Aircraft with a Temporary Certificate of Registration addressed to the new owner are allowed to travel internationally. It should be noted some countries such as Mexico may not recognize the Temporary Registration Card						
				    </div>
				</div>
					<div className="regulationcategory">Training &amp; Simulation</div>
					<div className="card-header">
						{/* <a name="qa-8"></a> */}
						<button className="btn btn-link accordion-button" type="button" data-toggle="collapse" data-target="#collapse-8" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">Conditions for logging Instrument Approaches per 14 CFR 61.57?</div>
						</button>
					</div>
					<div id="collapse-8" className="collapse accordion-display" aria-labelledby="heading-8" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						Pilots logging Instrument Approaches per 14 CFR 61.57 are allowed per the following:<br /><br /><ol><li>Actual instrument flight conditions flown in an aircraft;</li><li>Simulated instrument flight conditions, using a view-limiting device, flown in an aircraft with a safety pilot;</li><li>Simulated instrument flight conditions conducted in any FAA approved:<br /><br /><ol><li>Flight Simulator/Full Flight Simulator (FFS),</li><li>Flight Training Device (FTD),</li><li>Aviation Training Device (ATD), or</li><li>A combination of methods 1 through 3 as prescribed by 61.57(c)(4), or (5).</li></ol></li></ol>						
				    </div>
				</div>
					<div className="regulationcategory">Medical Not Required</div>
					<div className="card-header">
						{/* <a name="qa-9"></a> */}
						<button className="btn btn-link accordion-button" type="button" data-toggle="collapse" data-target="#collapse-9" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">When is a Medical not required</div>
						</button>
					</div>
					<div id="collapse-9" className="collapse accordion-display" aria-labelledby="heading-9" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						14 CFR 61.23(b)(8): When taking a practical test or a proficiency check for a certificate, rating, authorization or operating privilege conducted in a glider, balloon, flight simulator, or flight training device.						
				    </div>
				</div>
					<div className="regulationcategory">14 CFR 43.13(a)</div>
					<div className="card-header">
						{/* <a name="qa-13"></a> */}
						<button className="btn btn-link accordion-button" type="button" data-toggle="collapse" data-target="#collapse-13" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">Are maintenance instructions binding</div>
						</button>
					</div>
					<div id="collapse-13" className="collapse accordion-display" aria-labelledby="heading-13" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						The how-to instructions do not need to have any specific FAA acceptance or approval as long as the person using them has a reasonable expectation that the FAA will find it acceptable for the purpose for which it was created, when and if the FAA reviews it. In other words, all maintenance, preventive maintenance, rebuilding, and alterations must return an article to at least its original or properly altered condition with respect to the work performed. Therefore, the work must be done in an acceptable manner using methods, techniques, and practices acceptable to the FAA. <br />Reference 8900.1 Paragraph 6-2958(C)(3)						
				    </div>
				</div>
					<div className="regulationcategory">10 or More Seats 135.411(a)(2)</div>
					<div className="card-header">
						{/* <a name="qa-12"></a> */}
						<button className="btn btn-link accordion-button" type="button" data-toggle="collapse" data-target="#collapse-12" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">Number of Passenger Seats</div>
						</button>
					</div>
					<div id="collapse-12" className="collapse accordion-display" aria-labelledby="heading-12" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						Passenger seats are based on the number of installed seats.<br />FAA Legal Interpretation April 16, 2008 George Dukats.						
				    </div>
				</div>
					<div className="regulationcategory">Annex 6 Part II</div>
					<div className="card-header">
						{/* <a name="qa-14"></a> */}
						<button className="btn btn-link accordion-button" type="button" data-toggle="collapse" data-target="#collapse-14" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">Does 61.58 comply with Annex 6 Part II</div>
						</button>
					</div>
					<div id="collapse-14" className="collapse accordion-display" aria-labelledby="heading-14" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						Yes, under General Aviation Annex 6 Part II rules, a U.S. pilot having a check per 14 CFR 61.58 within the requirements of 24 months would meet the standard concerning proficiency checks. <br />Reference Annex 6 Part II Paragraph 3.9.4.4						
				    </div>
				</div>
					<div className="regulationcategory">14 CFR 135.263</div>
					<div className="card-header">
						{/* <a name="qa-15"></a> */}
						<button className="btn btn-link accordion-button" type="button" data-toggle="collapse" data-target="#collapse-15" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">May crewmember exceed planned flight time limitations under 135.267(b)</div>
						</button>
					</div>
					<div id="collapse-15" className="collapse accordion-display" aria-labelledby="heading-15" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						Yes if the flights to which he is assigned normally terminate within the limitations, but due to circumstances beyond the control of the certificate holder or flight crewmember (such as adverse weather conditions), are not at the time of departure expected to reach their destination within the planned flight time.                        <div className="far-file">
						<a href="/uploads/fars/15/135.267 kidd - (2012) (Planned Completion).pdf" target="_blank" rel="noreferrer">View File</a>
                        </div>
						
				    </div>
				</div>
					<div className="regulationcategory">14 CFR 135.269</div>
					<div className="card-header">
						{/* <a name="qa-4"></a> */}
						<button className="btn btn-link accordion-button" type="button" data-toggle="collapse" data-target="#collapse-4" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">May an augmented crew use 135.267 for the rest requirements?</div>
						</button>
					</div>
					<div id="collapse-4" className="collapse accordion-display" aria-labelledby="heading-4" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						No, the FAA is clear for an augmented crew 135.269 rest requirements are controlling.						
				    </div>
				</div>
					<div className="regulationcategory">14 CFR 205(d)(6)</div>
					<div className="card-header">
						{/* <a name="qa-16"></a> */}
						<button className="btn btn-link accordion-button" type="button" data-toggle="collapse" data-target="#collapse-16" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">May wristwatch be subsittuted for an onboard clock</div>
						</button>
					</div>
					<div id="collapse-16" className="collapse accordion-display" aria-labelledby="heading-16" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						No per 91.205(d)(6) and NTSB has ruled installed clock is required  to be considered an airworthy aircraft under IFR.                        <div className="far-file">
						<a href="/uploads/fars/16/Nkugba_2016_Legal_Interpretation.pdf" target="_blank" rel="noreferrer">View File</a>
                        </div>
						
				    </div>
				</div>
					<div className="regulationcategory">Unmonitored ILS or Localizer</div>
					<div className="card-header">
						{/* <a name="qa-17"></a> */}
						<button className="btn btn-link accordion-button" type="button" data-toggle="collapse" data-target="#collapse-17" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">Use of unmonitored NAVAID</div>
						</button>
					</div>
					<div id="collapse-17" className="collapse accordion-display" aria-labelledby="heading-17" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						When a navigational aid's operational status cannot be monitored at the controlling or monitoring facility, but all indications or reports are the facility is operating normally, issue a NOTAM placing the NAVAID in an unmonitored status. The NAVAID may be used for operations. <br />Reference: Order JO 7930.2M						
				    </div>
				</div>
					<div className="regulationcategory">Check Ride Discontinuance</div>
					<div className="card-header">
						{/* <a name="qa-18"></a> */}
						<button className="btn btn-link accordion-button" type="button" data-toggle="collapse" data-target="#collapse-18" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">May a check ride be discontinued for a revenue flight flight be part of a r</div>
						</button>
					</div>
					<div id="collapse-18" className="collapse accordion-display" aria-labelledby="heading-18" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						No, there are three reasons to stop a checkride,  weather, mechanical and illness. Checkrides need to be a continuance event. If stopped there should be documentation of the reasons and continuances within 60 days.						
				    </div>
				</div>
					<div className="regulationcategory">14 CFR 135.267(c)</div>
					<div className="card-header">
						{/* <a name="qa-1"></a> */}
						<button className="btn btn-link accordion-button" type="button" data-toggle="collapse" data-target="#collapse-1" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">May a crewmember exceed 14 hours of duty in 24 hour period?</div>
						</button>
					</div>
					<div id="collapse-1" className="collapse accordion-display" aria-labelledby="heading-1" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						No, however, the test in this scenario is the crewmember eligible under 135.267(c) to be considered scheduled.  The requirement is the prospective cadence of an assigned period i.e. a schedule with regularly assigned duty periods. If not then 135.267(b) would be applicable and the need to demonstrate 10 hours of rest prior to the assigned flight is required per 135.267(d). In this case, rest requirements are controlling and flight time limits may be exceeded given extenuating circumstances beyond the operator's control.                        <div className="far-file">
						<a href="/uploads/fars/1/135.267 jimenez - (2011) (Rolling Rest).pdf" target="_blank" rel="noreferrer">View File</a>
                        </div>
						
				    </div>
				</div>
					<div className="regulationcategory">14 CFR 120.105</div>
					<div className="card-header">
						{/* <a name="qa-19"></a> */}
						<button className="btn btn-link accordion-button" type="button" data-toggle="collapse" data-target="#collapse-19" aria-expanded="false" aria-controls="collapse-attending">
							<div className="plus-minus">+</div>
							<div className="label">Whom shall be drug tested?</div>
						</button>
					</div>
					<div id="collapse-19" className="collapse accordion-display" aria-labelledby="heading-19" data-parent="#regulationcontainer">
						<div className="regulationanswer">
						From the FAA legal interpretation of defining a person's required to be drug tested: It is the exercise of operational control and the determination that a flight can be conducted safely that the FAA considers the true safety-sensitive function.                         <div className="far-file">
						<a href="/uploads/fars/19/Jackson-Jackson &amp; Wade_2010_Legal_Interpretation.pdf" target="_blank" rel="noreferrer">View File</a>
 | 						<a href="/uploads/fars/19/Safety-Sensitive Job Categories Guidance Alert.pdf" target="_blank" rel="noreferrer">View File</a>
                        </div>
						
				    </div>
				</div>
	
			</div>
		</div></section>


    </div>
    <Footer />
  </div>
}

export default Regulations